import { HttpService } from "./http.service";
import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";

const basePath = "/Equipment";
const basePathMultiClient = "/EquipmentMulticlient";

const request = HttpService.handleRequest();

export const EquipmentService = {
  getAll,
  getList,
  insert,
  update,
  del,
  delById,
  copy,
  createMulticlient,
  getById,
  remove,
  insertOrUpdate,
  getAllList,
  getAllByEquipmentCode,
  setRecalculate, /* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */
  getMultiEquipmentGroup,
};

async function getAll() {
  return request.get(basePath);
}

async function insertOrUpdate(data) {
  return request.post(`${basePath}/create`, data);
}

async function insert(data) {
  return request.post(`${basePath}/InsertByProc`, data);
}

async function update(data) {
  return request.post(`${basePath}/InsertByProc`, data);
}

async function del(data) {
  return request.delete(basePath, { data });
}

async function delById(id) {
  return request.delete(`${basePath}/DeleteById/${id}`);
}

async function copy(data) {
  return request.post(`${basePath}/Copy`, data);
}

async function createMulticlient(data) {
  return request.post(`${basePath}/CreateMulticlient`, data);
}

async function remove(data) {
  return request.post(`${basePath}/remove`, data);
}

async function getById(id) {
  return request.get(`${basePath}/${id}`);
}

async function getAllByEquipmentCode(equipmentCode) {
  return request.get(
    `${basePathMultiClient}/GetAllByEquipmentCode/${equipmentCode}`
  );
}

async function getList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

async function getAllList() {
  return request.get(basePath + "/GetAllList");
}

/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */
async function setRecalculate(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/SetRecalculate`, data );
}
/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */

async function getMultiEquipmentGroup() {
  return request.get(basePath + "/GetMultiEquipmentGroup");
}

export default EquipmentService;
